import type { NodeDefinition } from "../domain/types/index.js";

function node(id: string, kind: NodeDefinition["kind"], x: number, y: number, next: readonly string[]): NodeDefinition {
  return { id, kind, x, y, next, ...(kind === "case" ? { caseId: id === "boss" ? "foresight-boss" : id } : {}) };
}

// 第15期。共有2件のあと、攻撃との相性で進路を選ぶ。中央への移動は局所的な一方通行。
export const MAP_NODES_FORESIGHT: Record<string, NodeDefinition> = Object.fromEntries([
  node("start", "start", 3, 0, ["p15-brief"]),
  node("p15-brief", "case", 3, 1, ["p15-prep"]),
  node("p15-prep", "case", 3, 2, ["p15-rollback", "p15-hand", "p15-fatigue"]),
  node("p15-rollback", "case", 1, 3, ["p15-review", "p15-rest4"]),
  node("p15-hand", "case", 3, 3, ["p15-triage"]),
  node("p15-fatigue", "case", 5, 3, ["p15-rest4r"]),
  node("p15-review", "case", 0, 4, ["p15-big-left"]),
  node("p15-rest4", "rest", 2, 4, ["p15-transfer"]),
  node("p15-triage", "case", 3, 4, ["p15-protocol", "p15-relic5"]),
  node("p15-rest4r", "rest", 6, 4, ["p15-staff"]),
  node("p15-big-left", "case", 0, 5, ["p15-left6"]),
  node("p15-protocol", "case", 3, 5, ["p15-transfer", "p15-mid6"]),
  node("p15-relic5", "relic", 4, 5, ["p15-mid6"]),
  node("p15-staff", "case", 6, 5, ["p15-big-right"]),
  node("p15-left6", "case", 0, 6, ["p15-rest7"]),
  node("p15-transfer", "case", 2, 6, ["p15-rest7", "p15-paper7"]),
  node("p15-mid6", "case", 4, 6, ["p15-paper7", "p15-fatigue7"]),
  node("p15-big-right", "case", 6, 6, ["p15-fatigue7"]),
  node("p15-rest7", "rest", 1, 7, ["p15-left8"]),
  node("p15-paper7", "case", 3, 7, ["p15-relic8"]),
  node("p15-fatigue7", "case", 5, 7, ["p15-right8", "p15-rest8r"]),
  node("p15-left8", "case", 1, 8, ["p15-left9", "p15-big-mid"]),
  node("p15-relic8", "relic", 3, 8, ["p15-big-mid"]),
  node("p15-right8", "case", 5, 8, ["p15-right9"]),
  node("p15-rest8r", "rest", 6, 8, ["p15-right9"]),
  node("p15-left9", "case", 1, 9, ["p15-rest10l"]),
  node("p15-big-mid", "case", 3, 9, ["p15-rest10l", "p15-rest10r"]),
  node("p15-right9", "case", 5, 9, ["p15-rest10r"]),
  node("p15-rest10l", "rest", 2, 10, ["p15-left11"]),
  node("p15-rest10r", "rest", 4, 10, ["p15-right11"]),
  node("p15-left11", "case", 2, 11, ["p15-left12"]),
  node("p15-right11", "case", 4, 11, ["p15-right12"]),
  node("p15-left12", "case", 2, 12, ["p15-final-left"]),
  node("p15-right12", "case", 4, 12, ["p15-final-right"]),
  node("p15-final-left", "case", 2, 13, ["boss"]),
  node("p15-final-right", "case", 4, 13, ["boss"]),
  node("boss", "case", 3, 14, []),
].map(n => [n.id, n]));
